/**
 * Google Ads conversion tracking helpers.
 *
 * Base gtag.js loader lives in index.html (AW-18145188364 + GA4 G-96B1KNFCKN).
 * These helpers fire `event: 'conversion'` calls at meaningful business events
 * (signup, lead, purchase) instead of on every pageview.
 *
 * Project standard: USD is the universal currency (see project memory).
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

const SIGNUP_CONVERSION_ID = "AW-18145188364/bT3QCL3lrr4cEIy0psxD";

/**
 * Fire the Google Ads "Sign-up" conversion. Safe to call from anywhere —
 * silently no-ops if gtag isn't loaded (e.g. SSR or ad-blocker).
 * Pass a stable userId to dedupe (only fires once per user across sessions).
 */
export function trackSignupConversion(userId?: string) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  if (userId) {
    const storageKey = `gads_signup_fired_${userId}`;
    try {
      if (localStorage.getItem(storageKey)) return;
      localStorage.setItem(storageKey, "1");
    } catch {
      // localStorage unavailable — fire anyway
    }
  }

  window.gtag("event", "conversion", {
    send_to: SIGNUP_CONVERSION_ID,
    value: 1.0,
    currency: "USD",
  });
}
